module.exports = __webpack_public_path__ + "img/img-3-3.ab7545ae.png";